import Slider from '../../../framework/slider';
import { screenSmallerThan } from '../../../shared/utilities/screenSize';
import { hideElement } from '../../../shared/utilities/show-hide';

type addSubscriptionsType = () => void;
type addEventListenersType = () => void;
type initializeLoryType = () => void;

export default class CardContainer extends Slider {
	private totalCards: number;
	private initialCards: number;
	private currentCounter: number;
	private loadMoreBtn: HTMLElement;

	constructor(element:HTMLElement) {
		super({
			element,
			dotContainer: '.v2-slider__dots',
			slideContainer: '.v2-slider',
			createBullets: true,
			sliderOpts: {
				infinite: false
			}
		});

		this.initializeLory();
		this.publishBreakpointOnResize();
		this.addSubscriptions();
		this.addEventListeners();
	}

	addEventListeners: addEventListenersType = (): void => {
		this.totalCards = +this.element.getAttribute('data-tot-items');
		this.initialCards = +this.element.getAttribute('data-int-items');
		this.currentCounter = this.initialCards;
		this.loadMoreBtn = this.element.querySelector(`[data-ref="load-more__button"]`);
		if (this.loadMoreBtn) {
			this.loadMoreBtn.addEventListener('click', e => {
				e.preventDefault();

				Array.from(this.element.querySelectorAll(`[data-show-award="false"]`)).forEach(
					(el:HTMLElement, index:number) => {
						if (index < this.initialCards) {
							el.setAttribute('data-show-award', 'true');
							this.currentCounter++;
						}
						if (this.currentCounter === this.totalCards) {
							hideElement(this.loadMoreBtn);
						}
					}
				);
			});
		}
	}

	initializeLory: initializeLoryType = (): void => {
		if (!this.slider && this.dotCount > 1 && screenSmallerThan('sm')) {
			this.initLory(this.slideContainer);
		}
	}

	addSubscriptions: addSubscriptionsType = (): void => {
		this.subscribe('SITE.BREAKPOINT', this.initializeLory.bind(this));        
	}
}
